import React from 'react';
import { Badge, IconButton } from '@mui/material';
import { Chat as ChatIcon } from '@mui/icons-material';

/**
 * Composant Badge pour afficher les notifications de messages
 */
const MessageNotificationBadge = ({ 
  unreadCount = 0, 
  onClick,
  children,
  color = 'error',
  variant = 'standard'
}) => {
  if (children) {
    // Mode wrapper : entoure un composant existant
    return (
      <Badge 
        badgeContent={unreadCount > 0 ? unreadCount : null}
        color={color}
        variant={variant}
        overlap="rectangular"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          '& .MuiBadge-badge': {
            fontSize: '0.75rem',
            height: 20,
            minWidth: 20,
            padding: '0 4px'
          }
        }}
      >
        {children}
      </Badge>
    );
  }

  // Mode bouton : affiche un bouton de chat avec badge
  return (
    <Badge 
      badgeContent={unreadCount > 0 ? unreadCount : null}
      color={color}
      variant={variant}
    >
      <IconButton 
        onClick={onClick}
        size="small"
        sx={{
          backgroundColor: 'primary.main',
          color: 'primary.contrastText',
          '&:hover': {
            backgroundColor: 'primary.dark'
          }
        }}
      >
        <ChatIcon fontSize="small" />
      </IconButton>
    </Badge>
  );
};

export default MessageNotificationBadge;
